import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ShieldCheck, ShieldOff, ExternalLink } from "lucide-react";

export default function DriveConnect() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  async function load() {
    const { data } = await api.get("/drive/status");
    setStatus(data);
  }
  useEffect(() => { load(); }, []);

  async function connect() {
    setLoading(true);
    try {
      const { data } = await api.get("/drive/connect");
      if (data.authorization_url) window.location.href = data.authorization_url;
    } catch (e) {
      alert("Error: " + (e.response?.data?.detail || e.message));
    } finally { setLoading(false); }
  }

  async function disconnect() {
    if (!window.confirm("¿Desconectar Google Drive de este tenant?")) return;
    await api.post("/drive/disconnect");
    load();
  }

  if (!status) return <div className="text-dim">Cargando...</div>;

  return (
    <div data-testid="drive-connect">
      <div className="card">
        <div className="flex items-center gap-3 mb-4">
          <div style={{ width: 48, height: 48, borderRadius: 10, background: "var(--bg-3)", display: "grid", placeItems: "center" }}>
            {status.connected ? <ShieldCheck size={24} className="text-success" /> : <ShieldOff size={24} className="text-dim" />}
          </div>
          <div>
            <h2 className="text-lg font-bold">Google Drive</h2>
            <div className="text-xs text-dim">{status.connected ? "Conectado" : status.configured ? "No conectado a este tenant" : "Servidor sin credenciales OAuth"}</div>
          </div>
        </div>

        {!status.configured && (
          <div className="card" style={{ background: "rgba(243,156,18,0.08)", border: "1px solid var(--warn)" }}>
            <div className="text-sm">⚠ El servidor aún no tiene configuradas las credenciales OAuth de Google (GOOGLE_CLIENT_ID y GOOGLE_CLIENT_SECRET). Pide al administrador del sistema que las configure en el archivo <code>.env</code> del backend siguiendo la guía oficial de Google Cloud Console.</div>
            <div className="text-xs text-dim mt-2">Mientras tanto, todos los archivos se almacenan localmente en el servidor.</div>
          </div>
        )}

        {status.configured && !status.connected && (
          <div>
            <p className="mb-3">Conecta este tenant con Google Drive para que todos los archivos cargados se respalden automáticamente en tu carpeta de Drive.</p>
            {status.folder_id && <p className="text-xs text-dim mb-3"><b>Folder ID configurado:</b> {status.folder_id}</p>}
            <button className="btn btn-primary" onClick={connect} disabled={loading} data-testid="drive-connect-btn">
              {loading ? <span className="spinner" /> : "Conectar Google Drive"}
            </button>
          </div>
        )}

        {!status.configured && status.folder_id && (
          <div className="mt-3 text-xs text-dim">
            <b>Carpeta destino preconfigurada:</b> {status.folder_id}
          </div>
        )}

        {status.connected && (
          <div>
            <div className="grid grid-cols-2 gap-3 mb-3">
              <div className="kpi-card"><div className="label">Carpeta raíz</div><div className="text-sm mt-2" style={{ wordBreak: "break-all" }}>{status.folder_id}</div></div>
              <div className="kpi-card"><div className="label">Última sincronización</div><div className="text-sm mt-2">{status.last_sync ? new Date(status.last_sync).toLocaleString("es-MX") : "-"}</div></div>
            </div>
            <div className="flex gap-2">
              {status.folder_id && (
                <a className="btn" href={`https://drive.google.com/drive/folders/${status.folder_id}`} target="_blank" rel="noreferrer">
                  <ExternalLink size={14} /> Abrir carpeta en Drive
                </a>
              )}
              <button className="btn btn-danger" onClick={disconnect}>Desconectar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
